<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="EBOOK INSTRUCTIONS"><h1 class="chapter" id="pz5-1ab"><a href="#/contenttoc#ba_01" id="ab_01"><b>EBOOK INSTRUCTIONS</b></a></h1>
<p class="noind_aa1">In this ebook edition, please use your device’s note-taking function to record your thoughts wherever you see the bracketed instructions [Your Notes] or [Your Response Here]. Use your device’s highlighting function to record your response whenever you are asked to checkmark, circle, underline, or otherwise indicate your answer(s).</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// instructions.vue?64ce34fc